import type { Language } from "../../types/BookitupDocument";

export const DEFAULT_DOCUMENT_LANGUAGE: Language = "german";

export type DocumentTranslationKey =
  | "documentNumberPrefix"
  | "originalInvoiceNumber"
  | "downloadSuffix"
  | "offerLabel"
  | "description"
  | "amount"
  | "price"
  | "total"
  | "subtotal"
  | "discount"
  | "totalAmount"
  | "totalAfterDiscountGross"
  | "totalAfterDiscountNet"
  | "vat"
  | "net"
  | "gross"
  | "taxModeGross"
  | "taxModeNet"
  | "claimAmount"
  | "remainingAmountDue"
  | "finalInvoiceLabel"
  | "creditNoteLabel"
  | "offerAcceptanceText"
  | "acceptOfferButton"
  | "cancelButton"
  | "acceptedAt"
  | "offerConfirmSubject"
  | "offerConfirmText"
  | "completeOfferAddressTitle"
  | "completeOfferAddressText"
  | "partnerFirstName"
  | "partnerLastName"
  | "streetAndHouseNumber"
  | "zipCode"
  | "city"
  | "phoneNumber"
  | "requiredField"
  | "saveAndAcceptOfferButton"
  | "and"
  | "phoneLabel"
  | "website"
  | "vatIdLabel"
  | "taxNumberLabel"
  | "transferQrTitle"
  | "transferQrDescription"
  | "paypalQrTitle"
  | "paypalQrDescriptionStart"
  | "paypalQrDescriptionLink"
  | "paypalQrDescriptionEnd";

type I18nLike = {
  _: (id: string) => string;
};

export type DocumentTranslator = (key: DocumentTranslationKey) => string;

const GENERATED_DOCUMENT_TEXT_TRANSLATION_KEYS: Record<
  string,
  DocumentTranslationKey
> = {
  Angebot: "offerLabel",
  Schlussrechnung: "finalInvoiceLabel",
  Gutschrift: "creditNoteLabel",
};

const resolveDocumentLanguage = (language?: Language): Language => {
  return language ?? DEFAULT_DOCUMENT_LANGUAGE;
};

export const getDocumentLanguageTranslationKey = (
  language: Language | undefined,
  key: DocumentTranslationKey
): string => {
  return `${resolveDocumentLanguage(language)}.${key}`;
};

export const getDocumentTranslator = (
  i18n: I18nLike,
  language?: Language
): DocumentTranslator => {
  return (key) => i18n._(getDocumentLanguageTranslationKey(language, key));
};

export const translateGeneratedDocumentText = (
  text: string | null | undefined,
  t: DocumentTranslator
): string | null | undefined => {
  if (!text) {
    return text;
  }

  return Object.entries(GENERATED_DOCUMENT_TEXT_TRANSLATION_KEYS).reduce(
    (translatedText, [sourceText, translationKey]) =>
      translatedText.split(sourceText).join(t(translationKey)),
    text
  );
};
